export default function ContactInfo() {
  return (
    <div className="md:w-1/2 mb-12 md:mb-0 md:pr-8">
      <h1 className="text-4xl font-bold text-gray-800 mb-6">Contact DevsKe</h1>
      <p className="text-xl text-gray-600 mb-8">Have questions or ready to start your project? Reach out to our team—we're happy to help!</p>
      
      <div className="space-y-6">
        <div className="flex items-start">
          <div className="text-blue-600 text-2xl mr-4 mt-1">
            <i className="fas fa-map-marker-alt"></i>
          </div>
          <div>
            <h3 className="font-bold text-gray-800 mb-1">Our Office</h3>
            <p className="text-gray-600">Nairobi Business Park, Ngong Road<br />Nairobi, Kenya</p>
          </div>
        </div>
        
        <div className="flex items-start">
          <div className="text-blue-600 text-2xl mr-4 mt-1">
            <i className="fas fa-phone-alt"></i>
          </div>
          <div>
            <h3 className="font-bold text-gray-800 mb-1">Call Us</h3>
            <p className="text-gray-600">+254 112 120 270<br />Mon-Fri, 8am-5pm EAT</p>
          </div>
        </div>
        
        <div className="flex items-start">
          <div className="text-blue-600 text-2xl mr-4 mt-1">
            <i className="fas fa-envelope"></i>
          </div>
          <div>
            <h3 className="font-bold text-gray-800 mb-1">Email Us</h3>
            <p className="text-gray-600">info@devsinkenya.com<br />support@devsinkenya.com</p>
          </div>
        </div>
      </div>
      
      <div className="mt-10">
        <h3 className="font-bold text-gray-800 mb-4">Follow Us</h3>
        <div className="flex space-x-4">
          <a 
            href="https://twitter.com/devske" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-700 text-2xl"
            aria-label="Twitter"
          >
            <i className="fab fa-twitter"></i>
          </a>
          <a 
            href="https://linkedin.com/company/devske" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-700 text-2xl"
            aria-label="LinkedIn"
          >
            <i className="fab fa-linkedin"></i>
          </a>
          <a 
            href="https://facebook.com/devske" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-700 text-2xl"
            aria-label="Facebook"
          >
            <i className="fab fa-facebook"></i>
          </a>
          <a 
            href="https://instagram.com/devske" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-700 text-2xl"
            aria-label="Instagram"
          >
            <i className="fab fa-instagram"></i>
          </a>
        </div>
      </div>
    </div>
  );
}